import React, {PropTypes as T} from 'react';
import './new-bubble.less';
import Anchor from 'b3/anchor/Anchor';
import cx from 'classnames';

export default class NewBubble extends React.Component {

    static propTypes = { 
    	target: T.object.isRequired,
    	position: T.string,
    	align: T.string,
		backgroundColor: T.string,
        onMouseOver: T.func,
        onMouseOut: T.func,
        onOutsideClick: T.func,
    };

    static defaultProps = { 
		backgroundColor: 'white',
        onMouseOver: () => {},
        onMouseOut: () => {},
        position: 'bottom',
        align: 'both',
        onOutsideClick: () => {},
    };

	render() {

		var className = cx(
			"b3-new-bubble",
			`b3-new-bubble-position-${this.props.position}`,
			`b3-new-bubble-align-${this.props.align}`,
		);

        className += (" " + this.props.className);

        return (
            <Anchor target={this.props.target} position={this.props.position} align={this.props.align} onOutsideClick={this.props.onOutsideClick} onMouseOver={this.props.onMouseOver} onMouseOut={this.props.onMouseOut}>
	            <div className={className}>
	            	<div className="b3-new-bubble-caret" style={{ borderColor: this.props.backgroundColor }} />
	            	<div className="b3-new-bubble-inner" style={{ background: this.props.backgroundColor }}>
		        		{this.props.children}
		        	</div>
	            </div>
            </Anchor>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/bubble/NewBubble.js